import classNames from 'classnames'
import styles from './Card.module.css'
import { CardProps, CommonCardProps } from './types'
import { type ForwardedRef, forwardRef } from 'react'

const Card = forwardRef(function Card(
  { as: Tag = 'div', className, children, size, ...props }: CardProps,
  ref: ForwardedRef<HTMLElement>
) {
  return (
    <Tag
      {...(props as CommonCardProps)}
      className={classNames(styles.container, className, styles[`size-${size}`])}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ref={ref as ForwardedRef<any>}
    >
      {children}
    </Tag>
  )
})

export default Card
